"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _distributionAlliance = require("@/api/distributionAlliance");
var _permission = require("@/utils/permission");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'AlliancePromoterApply',
  data: function data() {
    return {
      loading: false,
      saving: false,
      list: [],
      total: 0,
      query: {
        status: 0,
        keyword: '',
        page: 1,
        size: 20
      },
      rejectVisible: false,
      rejectRemark: '',
      rejectRow: null
    };
  },
  computed: {
    /**
     * 一键通过是单独的权限，不是「能进这个页面就能一键批」——
     * 它跳过条件判定，等于把审核这道关整个让开，得能单独授予和回收。
     */
    canQuickPass: function canQuickPass() {
      return (0, _permission.checkPermi)(['distribution:promoter:apply:quick']);
    }
  },
  created: function created() {
    this.load(1);
  },
  methods: {
    load: function load(page) {
      var _this = this;
      if (page) this.query.page = page;
      this.loading = true;
      var params = {
        page: this.query.page,
        size: this.query.size
      };
      if (this.query.status !== null && this.query.status !== '') params.status = this.query.status;
      if (this.query.keyword) params.keyword = this.query.keyword;
      (0, _distributionAlliance.getPromoterApplies)(params).then(function (res) {
        _this.list = res && res.list || [];
        _this.total = res && res.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    reset: function reset() {
      this.query = {
        status: null,
        keyword: '',
        page: 1,
        size: 20
      };
      this.load(1);
    },
    onSize: function onSize(size) {
      this.query.size = size;
      this.load(1);
    },
    approve: function approve(row) {
      var _this2 = this;
      this.$confirm("\u786E\u8BA4\u901A\u8FC7 ".concat(row.realName || row.uid, " \u7684\u6DD8\u5BA2\u7533\u8BF7\uFF1F"), '提示', {
        type: 'warning'
      }).then(function () {
        return (0, _distributionAlliance.approvePromoterApply)(row.id);
      }).then(function () {
        _this2.$message.success('已通过');
        _this2.load();
      }).catch(function () {});
    },
    quickApprove: function quickApprove(row) {
      var _this3 = this;
      this.$confirm('一键通过会跳过条件判定直接批准，操作会被记录（谁点的、什么时候、批了谁）。确认继续？', '绿色通道', {
        type: 'warning'
      }).then(function () {
        return (0, _distributionAlliance.quickApprovePromoterApply)(row.id);
      }).then(function () {
        _this3.$message.success('已一键通过');
        _this3.load();
      }).catch(function () {});
    },
    openReject: function openReject(row) {
      this.rejectRow = row;
      this.rejectRemark = '';
      this.rejectVisible = true;
    },
    submitReject: function submitReject() {
      var _this4 = this;
      if (!this.rejectRemark.trim()) {
        this.$message.warning('驳回必须填写理由');
        return;
      }
      this.saving = true;
      (0, _distributionAlliance.rejectPromoterApply)(this.rejectRow.id, this.rejectRemark.trim()).then(function () {
        _this4.$message.success('已驳回');
        _this4.rejectVisible = false;
        _this4.load();
      }).finally(function () {
        _this4.saving = false;
      });
    },
    statusText: function statusText(status) {
      return {
        0: '待审核',
        1: '已通过',
        2: '已驳回'
      }[status] || '—';
    },
    statusType: function statusType(status) {
      return {
        0: 'warning',
        1: 'success',
        2: 'info'
      }[status] || 'info';
    }
  }
};